import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { graphql } from 'gatsby';
import { Layout } from '../components/Layout';
import {
  ControlPanel,
  QuestionsList,
} from '../components/faq';
import {
  SimpleHero,
} from '../components/common';
import {
  useMousePosition,
  useDimensions,
  useScrollPosition,
} from '../util/hooks';
import { isClient } from '../util/helpers';


const FrequentlyAskedQuestions = (props) => {
  const {
    data: {
      page: {
        data: pageData,
      },
    },
    location,
  } = props;
  const {
    heroTitle,
    questions,
    metaTitle,
    metaDescription,
    openGraphImage,
  } = pageData;
  const seoData = {
    metaTitle,
    metaDescription,
    openGraphImage,
  };
  const [visibleQuestions, setVisibleQuestions] = useState(questions);
  const [activeCategory, setActiveCategory] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchActive, setSearchActive] = useState(false);
  const {
    x: cursorX,
    y: cursorY,
  } = useMousePosition();
  const {
    viewportWidth,
    viewportHeight,
    documentHeight,
  } = useDimensions();
  const viewportTopPos = useScrollPosition();
  if (isClient) document.documentElement.style.setProperty('--bg-colour', '#FFFFF4');
  const categories = questions.map(((faqItem) => {
    if (!faqItem.category) return null;
    return faqItem.category.document[0].data.categoryName.text;
  }));
  const uniqueCategories = [...new Set(categories)];
  const faqSchemaData = questions && questions.length > 0 && questions.map((questionItem) => {
    const {
      question,
      answer,
    } = questionItem;
    return (
      {
        '@type': 'Question',
        name: question.text,
        acceptedAnswer: {
          '@type': 'Answer',
          text: answer.text,
        },
      }
    );
  });
  const setSearchHandler = (event) => {
    const newSearchQuery = event.target.value.toLowerCase() || '';
    setSearchQuery(newSearchQuery);
    queryQuestions(activeCategory, newSearchQuery);
  };
  const setCategoryHandler = (event, newCategory) => {
    if (event) event.preventDefault();
    if (newCategory !== activeCategory) {
      setActiveCategory(newCategory);
      queryQuestions(newCategory, searchQuery);
    }
  };
  const queryQuestions = (newCategory, newSearchQuery) => {
    let matchingQuestions = questions;
    if (searchQuery !== newSearchQuery) {
      matchingQuestions = questions.filter(faqItem => (
        faqItem.question.text.toLowerCase().includes(newSearchQuery)
      ));
    }
    if (newCategory !== activeCategory) {
      matchingQuestions = matchingQuestions.filter((faqItem) => {
        if (newCategory === null) return true;
        const thisCategory = faqItem.category.document[0].data.categoryName.text;
        return newCategory === thisCategory;
      });
    }
    setVisibleQuestions(matchingQuestions);
  };
  const searchFocusHandler = (event, clicked) => {
    event.preventDefault();
    setSearchActive(clicked);
  };
  return (
    <Layout
      location={location}
      seoData={seoData}
      cursorX={cursorX}
      cursorY={cursorY}
      viewportWidth={viewportWidth}
      viewportHeight={viewportHeight}
      documentHeight={documentHeight}
      viewportTopPos={viewportTopPos}
    >
      <Helmet>
        <script
          className="structured-data-list"
          type="application/ld+json"
        >
          {JSON.stringify(faqSchemaData)}
        </script>
      </Helmet>
      <SimpleHero
        title={heroTitle.text}
      />
      <ControlPanel
        activeCategory={activeCategory}
        uniqueCategories={uniqueCategories}
        setActiveCategoryHandler={setCategoryHandler}
        searchActive={searchActive}
        searchQuery={searchQuery}
        searchFocusHandler={searchFocusHandler}
        setSearchHandler={setSearchHandler}
        numResults={visibleQuestions.length}
      />
      <QuestionsList
        questions={visibleQuestions}
        location={location}
      />
    </Layout>
  );
};

export default FrequentlyAskedQuestions;

export const pageQuery = graphql`
query FrequentlyAskedQuestionsQuery {
  page: prismicFrequentlyAskedQuestions {
    uid,
    data {
      heroTitle: hero_title {
        text
      }
      questions {
        question {
          text
        }
        answer {
          text
          html
        }
        category {
          document {
            ... on PrismicQuestionCategory {
              id
              data {
                categoryName: category_name {
                  text
                }
              }
            }
          }
        }
      }
      metaTitle: meta_title {
        html
        text
      },
      metaDescription: meta_description {
        html
        text
      },
      openGraphImage: open_graph_image {
        alt
        copyright
        url
      }
    }
  }
}
`;
